module.exports = __webpack_public_path__ + "static/media/bangalore-zoo.4531d3f2.jpg";